export default class Manager {

    constructor(container) {
        this._container = container;
    }

    populate() {
        throw new Error("unimplemented interface");
    }

    update() {
        throw new Error("unimplemented interface");
    }

}